export default "__VITE_ASSET__DVfZZk1U__"